var dataList = {
    '新疆玛纳斯基地市': [86.22, 44.30],
    '九江市': [116.00, 29.70],
    '新乡市': [113.9267, 35.3032],
    '若羌县市': [88.17, 39.02],
    '上海市': [121.4648, 31.2891],
    '东莞市': [113.8953, 22.901],
    '东营市': [118.7073, 37.5513],
    '中山市': [113.4229, 22.478],
    '临汾市': [111.4783, 36.1615],
    '临沂市': [118.3118, 35.2936],
    '丹东市': [124.541, 40.4242],
    '丽水市': [119.5642, 28.1854],
    '乌鲁木齐市': [87.9236, 43.5883],
    '佛山市': [112.8955, 23.1097],
    '保定市': [115.0488, 39.0948],
    '兰州市': [103.5901, 36.3043],
    '包头市': [110.3467, 41.4899],
    '北京市': [116.4551, 40.2539],
    '北海市': [109.314, 21.6211],
    '南京市': [118.8062, 31.9208],
    '南宁市': [108.479, 23.1152],
    '南昌市': [116.0046, 28.6633],
    '南通市': [121.1023, 32.1625],
    '厦门市': [118.1689, 24.6478],
    '台州市': [121.1353, 28.6688],
    '合肥市': [117.29, 32.0581],
    '呼和浩特市': [111.4124, 40.4901],
    '咸阳市': [108.4131, 34.8706],
    '哈尔滨市': [127.9688, 45.368],
    '唐山市': [118.4766, 39.6826],
    '嘉兴市': [120.9155, 30.6354],
    '大同市': [113.7854, 39.8035],
    '大连市': [122.2229, 39.4409],
    '天津市': [117.4219, 39.4189],
    '太原市': [112.3352, 37.9413],
    '威海市': [121.9482, 37.1393],
    '宁波市': [121.5967, 29.6466],
    '宝鸡市': [107.1826, 34.3433],
    '宿迁市': [118.5535, 33.7775],
    '常州市': [119.4543, 31.5582],
    '广州市': [113.5107, 23.2196],
    '廊坊市': [116.521, 39.0509],
    '延安市': [109.1052, 36.4252],
    '张家口市': [115.1477, 40.8527],
    '徐州市': [117.5208, 34.3268],
    '德州市': [116.6858, 37.2107],
    '惠州市': [114.6204, 23.1647],
    '成都市': [103.9526, 30.7617],
    '扬州市': [119.4653, 32.8162],
    '承德市': [117.5757, 41.4075],
    '拉萨市': [91.1865, 30.1465],
    '无锡市': [120.3442, 31.5527],
    '日照市': [119.2786, 35.5023],
    '昆明市': [102.9199, 25.4663],
    '杭州市': [119.5313, 29.8773],
    '枣庄市': [117.323, 34.8926],
    '柳州市': [109.3799, 24.9774],
    '株洲市': [113.5327, 27.0319],
    '武汉市': [114.3896, 30.6628],
    '汕头市': [117.1692, 23.3405],
    '江门市': [112.6318, 22.1484],
    '沈阳市': [123.1238, 42.1216],
    '沧州市': [116.8286, 38.2104],
    '河源市': [114.917, 23.9722],
    '泉州市': [118.3228, 25.1147],
    '泰安市': [117.0264, 36.0516],
    '泰州市': [120.0586, 32.5525],
    '济南市': [117.1582, 36.8701],
    '济宁市': [116.8286, 35.3375],
    '海口市': [110.3893, 19.8516],
    '淄博市': [118.0371, 36.6064],
    '淮安市': [118.927, 33.4039],
    '深圳市': [114.5435, 22.5439],
    '清远市': [112.9175, 24.3292],
    '温州市': [120.498, 27.8119],
    '渭南市': [109.7864, 35.0299],
    '湖州市': [119.8608, 30.7782],
    '湘潭市': [112.5439, 27.7075],
    '滨州市': [117.8174, 37.4963],
    '潍坊市': [119.0918, 36.524],
    '烟台市': [120.7397, 37.5128],
    '玉溪市': [101.9312, 23.8898],
    '珠海市': [113.7305, 22.1155],
    '盐城市': [120.2234, 33.5577],
    '盘锦市': [121.9482, 41.0449],
    '石家庄市': [114.4995, 38.1006],
    '福州市': [119.4543, 25.9222],
    '秦皇岛市': [119.2126, 40.0232],
    '绍兴市': [120.564, 29.7565],
    '聊城市': [115.9167, 36.4032],
    '肇庆市': [112.1265, 23.5822],
    '舟山市': [122.2559, 30.2234],
    '苏州市': [120.6519, 31.3989],
    '莱芜市': [117.6526, 36.2714],
    '菏泽市': [115.6201, 35.2057],
    '营口市': [122.4316, 40.4297],
    '葫芦岛市': [120.1575, 40.578],
    '衡水市': [115.8838, 37.7161],
    '衢州市': [118.6853, 28.8666],
    '西宁市': [101.4038, 36.8207],
    '西安市': [109.1162, 34.2004],
    '贵阳市': [106.6992, 26.7682],
    '连云港市': [119.1248, 34.552],
    '邢台市': [114.8071, 37.2821],
    '邯郸市': [114.4775, 36.535],
    '郑州市': [113.4668, 34.6234],
    '鄂尔多斯市': [108.9734, 39.2487],
    '重庆市': [107.7539, 30.1904],
    '金华市': [120.0037, 29.1028],
    '铜川市': [109.0393, 35.1947],
    '银川市': [106.3586, 38.1775],
    '镇江市': [119.4763, 31.9702],
    '长春市': [125.8154, 44.2584],
    '长沙市': [113.0823, 28.2568],
    '长治市': [112.8625, 36.4746],
    '阳泉市': [113.4778, 38.0951],
    '青岛市': [120.4651, 36.3373],
    '韶关市': [113.7964, 24.7028],
    '信阳市': [114.0927, 32.1471],
    '洛阳市': [112.4536, 34.6181],
    '商丘市': [115.6563, 34.4142],
    '开封市': [114.3073, 34.7972],
    '平顶山市': [113.1924, 33.7660],
    '安阳市': [114.3931, 36.0977],
    '南阳市': [112.5285, 32.9907],
    '焦作市': [113.2420, 35.2156],
    '许昌市': [113.8523, 34.0357],
    '香港': [114.173355,22.320048],
    '其它':[],
    '台湾':[121.509062,25.044332],
    '澳门':[113.54909,22.198951],
    '钓鱼岛':[123.476492, 25.744676],
	"辽宁省":[123.429096,41.796767],
};

var henanCityData = {
    '郑州市':[113.665412, 34.757975],
    '开封市':[114.540931, 34.604519],
    '洛阳市':[112.037758, 34.292711],
    '平顶山市':[113.016538, 33.795822],
    '安阳市':[114.35892, 35.878316],
    '鹤壁市':[114.315141, 35.723401],
    '新乡市':[114.095126, 35.2642],
    '焦作市':[113.136708, 35.11139],
    '濮阳市':[115.287619, 35.809628],
    '许昌市':[113.715649, 34.07146],
    '漯河市':[113.905981, 33.654451],
    '三门峡市':[111.112333, 34.362048],
    '南阳市':[112.288667, 33.044874],
    '商丘市':[115.701994, 34.289443],
    '信阳市':[114.889063, 32.080414],
    '周口市':[114.883044, 33.722041],
    '驻马店市':[114.15633, 32.922684],
    '济源市':[112.3987, 35.099112],
    '其它':[]
}

module.exports = {
    dataList: dataList,
    henanCityData:henanCityData
}

